import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "text-h6 font-italic mb-2" }
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  style: {"width":"20px"},
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "text-subtitle-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_ctx.quotes.length)
        ? (_openBlock(), _createBlock(_component_v_carousel, {
            key: 0,
            cycle: "",
            "hide-delimiter-background": "",
            height: "100",
            class: "mt-5",
            "hide-delimiters": "",
            "show-arrows": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotes, (quote, index) => {
                return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("blockquote", _hoisted_2, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[0] || (_cache[0] = [
                          _createElementVNode("path", { d: "M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z" }, null, -1)
                        ]))),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(quote.text), 1)
                      ]),
                      _createElementVNode("div", _hoisted_4, "— " + _toDisplayString(quote.author), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}